import template from "./pD365Clients.html";

export function pD365ClientsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pD365ClientsController,
    controllerAs: 'pD365Clients',
    bindToController: true
  };

  return directive;
}

class pD365ClientsController {
  constructor($scope, $location, $interval, $q, Auth, Notes, D365, Sort, Utils, $translate) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Notes = Notes;
    this.D365 = D365;
    this.Sort = Sort;
    this.Utils = Utils;
    this.$translate = $translate;
    this.state = "loading";
    this.matchBlocked = false;

    this.headers = [
      {name: "D365.CLIENT_KLIX", class: "table-info"},
      {name: "D365.CLIENT_D365", class: "table-d365"}
    ];

    this.clientSearchPlaceholder = this.$translate.instant('D365.CLIENT_SEARCH_PLACEHOLDER');
    this.clientSearchTooltip = this.$translate.instant('D365.CLIENT_SEARCH_TOOLTIP');

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        //Notes...
        const timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 200);
        this.$scope.$on("$destroy", () => {
          this.$interval.cancel(timeout);
        });
        this.getData();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  getData() {
    this.D365.getClientMappers().then(
      (success) => {
        this.state = "loaded";
        if (success.data.length == 0 || !success.data) {
          this.noClients = true;
        } else {
          this.clientsKlix = success.data.sort(this.Sort.abcBy("name"));
          this.mapperToDisplay = this.getMapperToDisplay(this.clientsKlix);
        }
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  getMapperToDisplay(klixClients) {
    const mapperToDisplay = klixClients && klixClients.map(clientKlix => {

      let client = {
        ...clientKlix,
        clientId: clientKlix.id,
        clientName: clientKlix.name,
        d365ClientName: clientKlix.d365ClientName,
        unmatched: true,
        taxId: clientKlix.taxId
      };
      if (clientKlix.d365ClientName !== undefined) {
        client = {
          ...client,
          unmatched: false
        };
      }

      if (clientKlix.additionalInfo)
        client.nameWithAdditionalInfo = `(${clientKlix.additionalInfo}) ${clientKlix.name}`;

      return client;
    });
    return mapperToDisplay;
  }

  editClient(entity) {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.clientToMatch = {id: entity.d365ClientId, name: entity.d365ClientName, ...entity};
    this.hintClient = entity.clientName.substr(0, entity.clientName.indexOf(' ') + 1);
  }

  refresh() {
    this.getData();
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
  }

  saveClientMatch(client, d365client) {
    this.state = "loading";
    this.D365.saveClientClientMapper(
      client.clientId,
      angular.fromJson(d365client).d365ClientId,
      angular.fromJson(d365client).d365ClientName,
      angular.fromJson(d365client).d365ClientTaxId
    ).then(
      () => {
        this.clientToMatch = null;
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.clientToMatch = null;
  }

  back() {
    window.history.back();
  }

  deleteClient(entity) {
    this.state = "loading";
    this.D365.deleteClientClientMapper(entity.clientId).then(
      () => {
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  selectClient(client) {
    this.clientToMatch = client;
  }

  getClientsD365(query) {
    return this.D365.getClientsD365(query).then(
      (success) => {
        return success.data.map(client => ({
          d365ClientName: client.name,
          d365ClientId: client.id,
          d365ClientTaxId: client.taxId
        }));
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
        return [];
      }
    );
  }

  displayClientFn(item) {
    return `${item.d365ClientTaxId ? item.d365ClientTaxId + ' - ' : ''}${item.d365ClientName || ''}${item.d365ClientId ? ' - ' +item.d365ClientId : ''}`;
  }
}
